var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-alert",
        {
          attrs: {
            variant: "warning",
            dismissible: "",
            show: _vm.autoLogout.isAutoLogout
          }
        },
        [
          _vm.autoLogout.isAutoLogout
            ? _c("div", [
                _vm._v(
                  "\n      " +
                    _vm._s(
                      _vm.$t("message.signIn.autoLogout", {
                        salutation: _vm.$t(
                          "enums.salutations." + _vm.autoLogout.salutation
                        ),
                        firstName: _vm.autoLogout.firstName,
                        lastName: _vm.autoLogout.lastName
                      })
                    ) +
                    "\n    "
                )
              ])
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _c(
        "b-card",
        { staticClass: "rounded-0" },
        [
          _c("h4", { staticClass: "text-center" }, [
            _vm._v(_vm._s(_vm.$t("message.signIn.title")))
          ]),
          _vm._v(" "),
          _c(
            "b-form",
            {
              staticClass: "mt-3 p-3",
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.submit($event)
                }
              }
            },
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    state: _vm.$v.authData.email.$error ? false : null,
                    "invalid-feedback": _vm.$t("error.signIn.email")
                  }
                },
                [
                  _c("label", [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("message.signIn.label.email")) +
                        "\n          "
                    ),
                    _c("span", { staticClass: "text-danger" }, [_vm._v("*")])
                  ]),
                  _vm._v(" "),
                  _c("b-form-input", {
                    staticClass: "rounded-0",
                    attrs: {
                      id: "email",
                      autofocus: "",
                      placeholder: _vm.$t(
                        "message.signIn.input.placeholder.email"
                      ),
                      state: _vm.$v.authData.email.$error ? false : null
                    },
                    on: {
                      change: function($event) {
                        _vm.$v.authData.email.$touch()
                      }
                    },
                    model: {
                      value: _vm.authData.email,
                      callback: function($$v) {
                        _vm.$set(_vm.authData, "email", $$v)
                      },
                      expression: "authData.email"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-form-group",
                {
                  staticClass: "mt-4",
                  attrs: {
                    state: _vm.$v.authData.password.$error ? false : null,
                    "invalid-feedback": _vm.$t("error.signIn.password")
                  }
                },
                [
                  _c("label", [
                    _vm._v("\n          Passwort\n          "),
                    _c("span", { staticClass: "text-danger" }, [_vm._v("*")])
                  ]),
                  _vm._v(" "),
                  _c("b-form-input", {
                    staticClass: "rounded-0",
                    attrs: {
                      id: "password",
                      type: "password",
                      placeholder: _vm.$t(
                        "message.signIn.input.placeholder.password"
                      ),
                      state: _vm.$v.authData.password.$error ? false : null
                    },
                    on: {
                      change: function($event) {
                        _vm.$v.authData.password.$touch()
                      }
                    },
                    model: {
                      value: _vm.authData.password,
                      callback: function($$v) {
                        _vm.$set(_vm.authData, "password", $$v)
                      },
                      expression: "authData.password"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-form-row",
                { staticClass: "mt-4" },
                [
                  _c(
                    "b-col",
                    { staticClass: "text-right" },
                    [
                      _c("router-link", { attrs: { to: "/resetPassword" } }, [
                        _vm._v(_vm._s(_vm.$t("message.resetPassword.title")))
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-form-row",
                { staticClass: "mt-4" },
                [
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-btn",
                        {
                          staticClass: "w-100 p-3 rounded-0",
                          attrs: {
                            type: "submit",
                            variant: "primary",
                            disabled: _vm.$v.$invalid
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("message.signIn.title")) +
                              "\n          "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-form-row",
                { staticClass: "mt-4" },
                [
                  _c("b-col", { staticClass: "text-center" }, [
                    _c(
                      "p",
                      [
                        _vm._v(
                          _vm._s(_vm.$t("message.signUp.question")) +
                            "\n            "
                        ),
                        _c("router-link", { attrs: { to: "/signup" } }, [
                          _vm._v(_vm._s(_vm.$t("message.signUp.link")))
                        ])
                      ],
                      1
                    )
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0ae377c9", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0ae377c9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/auth/SignIn.vue
// module id = 3XlP
// module chunks = 1